import { SvgIcon, SvgIconProps } from '@mui/material'

export const ScheduleIcon = ({ fill, ...props }: SvgIconProps) => {
  return (
    <SvgIcon width="19" height="20" viewBox="0 0 19 20" fill="none" data-testid="ScheduleIcon" {...props}>
      <path
        d="M6.33331 9H4.33331V11H6.33331V9ZM10.3333 9H8.33331V11H10.3333V9ZM14.3333 9H12.3333V11H14.3333V9ZM16.3333 2H15.3333V0H13.3333V2H5.33331V0H3.33331V2H2.33331C1.22331 2 0.343313 2.9 0.343313 4L0.333313 18C0.333313 19.1 1.22331 20 2.33331 20H16.3333C17.4333 20 18.3333 19.1 18.3333 18V4C18.3333 2.9 17.4333 2 16.3333 2ZM16.3333 18H2.33331V7H16.3333V18Z"
        fill={fill}
      />
    </SvgIcon>
  )
}
